import { render, staticRenderFns } from "./VehiculeExpertise.vue?vue&type=template&id=28b3f71a&scoped=true&"
import script from "./VehiculeExpertise.vue?vue&type=script&lang=js&"
export * from "./VehiculeExpertise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b3f71a",
  null
  
)

export default component.exports